import { Badge } from "@/_v2/components/ui/badge";

import { FlagStatus, FLAG_STATUS_LABELS } from "../lib";

const STATUS_VARIANTS: Record<FlagStatus, "success" | "info" | "secondary"> = {
  global: "success",
  partial: "info",
  off: "secondary",
};

export const FlagStatusBadge = ({ status }: { status: FlagStatus }) => (
  <Badge variant={STATUS_VARIANTS[status]}>{FLAG_STATUS_LABELS[status]}</Badge>
);
